<!--
*****************************************
*										*
* NAGARRO  - CSX - CONFIDENTIAL         *
*										*
*****************************************
-->

<div class="col-sm-6 pdl5 train-details-div">
	<div class="content-heading text-uppercase">
		<h3>{{trainLabel?.trainDetails}} {{trainTypeValue}}</h3>
	</div>
	<div class="row">
		<div class="col-sm-4 pdr5">
			<div class="list-content">
				<ul class="list-unstyled">
					<li>
						<label>{{trainLabel?.tons}}: </label>
						<b>{{trainData?.tons? trainData?.tons : '-'}}</b>
					</li>
					<li>
						<label>{{trainLabel?.loads}}: </label>
						<b>{{trainData?.loads? trainData?.loads : '-'}}</b>
					</li>
					<li>
						<label>{{trainLabel?.tofc}}: </label>
						<b>{{trainData?.tofc? trainData?.tofc : '-'}}</b>

					</li>
				</ul>
			</div>
		</div>
		<div class="col-sm-4 pdl5 pdr5">
			<div class="list-content">
				<ul class="list-unstyled">
					<li>
						<label>{{trainLabel?.feet}}: </label> {{trainData?.length? trainData?.length : '-'}}
					</li>
					<li>
						<label>{{trainLabel?.empty}}: </label> {{trainData?.empties? trainData?.empties : '-'}}
					</li>
					<li>
						<label>{{trainLabel?.auto}}: </label> {{trainData?.autos? trainData?.autos : '-'}}
					</li>
				</ul>
			</div>
		</div>
		<div class="col-sm-4 pdl5 pdr5">
			<div class="list-content">
				<ul class="list-unstyled">
					<li>
						<label>{{trainLabel?.hp}}: </label> {{trainData?.totalWorkingHorsePower? trainData?.totalWorkingHorsePower : '-'}}
					</li>
					<li>
						<label>{{trainLabel?.car}}: </label> {{getTotalCars(trainData?.empties, trainData?.loads)}}
					</li>
					<li>
						<label>{{trainLabel?.hpTT}}: </label> {{trainData?.workingHPPerTrailTon? trainData?.workingHPPerTrailTon : '-'}}
					</li>
				</ul>
			</div>
		</div>
	</div>
</div>